/**
 * 到达节点类型（接口传参，前端筛选用）：0-仓库(whs)，1-枢纽(hub)
 */
export const ARRIVAL_POINT_TYPE_WHS = 0;
export const ARRIVAL_POINT_TYPE_HUB = 1;
export type ArrivalPointType = typeof ARRIVAL_POINT_TYPE_WHS | typeof ARRIVAL_POINT_TYPE_HUB;

/**
 * 从 URL 查询串解析「日期类型」，用于深链直达指定视图。
 * 仅 arrivalPointType=1 取「到达HUB时间」，其余（不传/0/非法值）一律回落「到达WHS时间」。
 */
export function parseArrivalPointTypeFromSearch(search: string): ArrivalPointType {
    const value = new URLSearchParams(search).get('arrivalPointType');
    return value === String(ARRIVAL_POINT_TYPE_HUB) ? ARRIVAL_POINT_TYPE_HUB : ARRIVAL_POINT_TYPE_WHS;
}

/**
 * 维度类型（与后端 DimensionType 一致）：area-区域，driver-司机，dsp-DSP，whs-仓库
 */
export const DIMENSION_AREA = 'area' as const;
export const DIMENSION_DRIVER = 'driver' as const;
export const DIMENSION_DSP = 'dsp' as const;
export const DIMENSION_WHS = 'whs' as const;
export type SlaDimensionType = typeof DIMENSION_AREA | typeof DIMENSION_DRIVER | typeof DIMENSION_DSP | typeof DIMENSION_WHS;
